<script setup>
import { computed } from 'vue'

// Props
const props = defineProps({
  size: {
    type: String,
    default: 'md',
    validator: (value) => ['sm', 'md', 'lg', 'xl'].includes(value)
  }
})

// Computed
const sizeClasses = computed(() => {
  const sizes = {
    sm: 'h-4 w-4',
    md: 'h-8 w-8',
    lg: 'h-12 w-12',
    xl: 'h-16 w-16'
  }
  return sizes[props.size]
})
</script>

<template>
  <div class="flex justify-center items-center">
    <div 
      class="animate-spin rounded-full border-4 border-gray-300 border-t-blue-600" 
      :class="sizeClasses"
    />
  </div>
</template>